'use client';
import React from 'react';
import Link from 'next/link';

export default function Custom404() {
  return (
    <div className="min-h-screen bg-gray-100 flex flex-col justify-center items-center">
      <div className="text-center">
        <h1 className="text-9xl font-bold text-gray-800">404</h1>
        <div className="absolute rotate-12 text-xl bg-yellow-400 px-2 text-white rounded">
          Page Not Found
        </div>
        <p className="mt-8 text-gray-600 text-2xl font-light">
          Oops! Trang bạn đang tìm kiếm không tồn tại.
        </p>
        <Link
          href="/"
          className="mt-6 inline-block px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition duration-300"
        >
          Trở về trang chủ
        </Link>
      </div>
      <div className="mt-8 text-gray-400">
        <p>© 2023 MePhimChill. All rights reserved.</p>
      </div>
    </div>
  );
}
